import { createFileRoute } from '@tanstack/react-router'

import ScreenLayout from '@/components/layout/ScreenLayout'
import TitleRow from '@/components/ui/TitleRow'
import FiredAlertList from '@/screens/app/inbox/components/FiredAlertList'
import FiredAlertsBanner from '@/screens/app/inbox/components/FiredAlertsBanner'

export const Route = createFileRoute('/_app/notifications')({ component: NotificationsScreen })

/**
 * Notifications (f09) — the member's fired alerts, and nothing else.
 *
 * mm-be v5 publishes no notifications endpoint (no feed, no read state, no
 * unread count), so the one thing it can source is an alert that fired —
 * `GET /api/v5/alerts/`, which the Alerts screen owns the rules of. The
 * design's other kinds (circuit hits, dividends, EDIS, IPO reminders,
 * statement imports), its unread dots, "Mark all read", the For you / All
 * split and "View more" all need a feed and stay unbuilt: with one kind of
 * notification a split would filter nothing, and with no read state there is
 * nothing to mark.
 */
function NotificationsScreen() {
  return (
    <ScreenLayout header={<TitleRow title="Notifications" back="/" />} pageTitle="Notifications">
      <div className="flex flex-col gap-6">
        <FiredAlertList />
        <FiredAlertsBanner />
      </div>
    </ScreenLayout>
  )
}
